// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noty_layout {\n  min-height: 80px;\n  bottom: 80px !important;\n}\n\n.noty_bar {\n  padding: 15px 15px 15px 20px;\n  border-radius: 3px;\n  background-position: 15px center;\n  background-repeat: no-repeat;\n  -webkit-box-shadow: 0 0 12px #999;\n  box-shadow: 0 0 12px #999;\n  opacity: 0.9;\n}\n\n.noty_body {\n  padding: unset !important;\n}\n\n.noty_theme__bootstrap-v4.noty_type__error {\n  background-color: #bd362f;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
